/** Wall clock that re-renders on an interval — countdowns and "received … ago" labels. */
import { useEffect, useState } from "react";

export function useNow(intervalMs = 30_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}

/** "in 47h 12m" / "overdue 2h 05m" */
export function countdownLabel(targetIso: string, now: Date): { text: string; overdue: boolean } {
  const ms = new Date(targetIso).getTime() - now.getTime();
  const abs = Math.abs(ms);
  const h = Math.floor(abs / 3_600_000);
  const m = Math.floor((abs % 3_600_000) / 60_000);
  const body = h >= 48 ? `${Math.floor(h / 24)}d ${h % 24}h` : `${h}h ${String(m).padStart(2, "0")}m`;
  return ms >= 0 ? { text: `in ${body}`, overdue: false } : { text: `overdue ${body}`, overdue: true };
}
